import SetupClassTeacher from "components/module/setupClassTeacher"

const ClassSetupFinesPage = () => {
  return <SetupClassTeacher variant="fine" />
}

export default ClassSetupFinesPage
